import { render } from "./LinkProductsToPromotionModal.html?vue&type=template&id=aa90b7ae&scoped=true"
import script from "./LinkProductsToPromotionModal.js?vue&type=script&lang=js"
export * from "./LinkProductsToPromotionModal.js?vue&type=script&lang=js"

import "./LinkProductsToPromotionModal.css?vue&type=style&index=0&id=aa90b7ae&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/Shiptech MyPlusRewards/mpr-web-admin-portal/src/MPR.MyPlusRewardsAdminPortal.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa90b7ae"]])

export default __exports__